module.exports = __webpack_public_path__ + "img/educ.a1d8188f.png";